import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faBullseye } from "@fortawesome/free-solid-svg-icons";

function AddSavingGoalForm({ onSavingGoalAdded }) {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [currency, setCurrency] = useState('EUR');
  const [goal, setGoal] = useState('');
  const [imageUrl, setImageUrl] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/saving-goals`, { name, currency, goal, imageUrl });
      onSavingGoalAdded();
      setName('');
      setCurrency('EUR');
      setGoal('');
      setImageUrl('');
    } catch (error) {
      console.error('Error adding saving goal:', error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="card bg-white dark:bg-dark-surface p-6 mb-6 transition-colors">
      <h3 className="text-lg font-bold text-gray-800 dark:text-white mb-4 flex items-center gap-2">
        <FontAwesomeIcon icon={faBullseye} className="text-primary-500" />
        {t('addSavingGoal')}
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="md:col-span-2">
          <label htmlFor="name" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">{t('name')}</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t('enterGoalName')}
            className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
            required
          />
        </div>
        
        <div>
          <label htmlFor="goal" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">{t('goal')}</label>
          <input
            type="number"
            id="goal"
            value={goal}
            onChange={(e) => setGoal(e.target.value)}
            placeholder={t('enterGoalAmount')}
            className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
            required
          />
        </div>
        
        <div>
          <label htmlFor="currency" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">{t('currency')}</label>
          <select
            id="currency"
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
          >
            <option value="EUR">EUR</option>
            <option value="USD">USD</option>
            <option value="UAH">UAH</option>
            <option value="HUF">HUF</option>
          </select>
        </div>
        
        <div className="md:col-span-2">
          <label htmlFor="imageUrl" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">{t('imageUrl')}</label>
          <input
            type="text"
            id="imageUrl"
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
            placeholder={t('enterImageUrl')}
            className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
          />
        </div>
      </div>
      
      <button 
        type="submit" 
        className="btn-primary w-full py-3 rounded-xl flex items-center justify-center gap-2 font-bold"
      >
        <FontAwesomeIcon icon={faPlus} />
        {t('addSavingGoal')}
      </button>
    </form>
  );
}

export default AddSavingGoalForm;